import { Fragment } from 'react';
import './index.css';
function AndroidPageStaging() {
    return <Fragment >
        <div className="android-page">
            <div className="content">
                <img src="assets/img/android/1.png" alt="" />
                <a className='btndownload' href="https://milocalapp.firebaseapp.com/assets/staging-mdh/milocal-1.20.1-staging-android-281781d.apk" target="_self">
                    <img src="assets/img/android/2.png" alt="" />
                </a>
                <img className='mb-2 card' src="assets/img/android/3.png" alt="" />
                <img className='mb-2 card' src="assets/img/android/4.png" alt="" />
                <img className='mb-2 card' src="assets/img/android/5.png" alt="" />
                <img className='mb-2' src="assets/img/android/6.png" alt="" />
            </div>
        </div>

    </Fragment>

}

export default AndroidPageStaging;
